import * as Config from '../../../config';
import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import './AddPlaylist.css'

import NewPlaylist from './NewPlaylist';
import Button from '../common/Button';
import IconPlus from '../svg/IconPlus';
import Playlist from './Playlist';
import ModalCTA from '../modal/ModalCTA';
import ModalButton from '../modal/ModalButton';

import { FormContext } from '../../../contexts/form-context';
import useApiOrLocal from '../../../hooks/useApiOrLocal';

import { connect } from "react-redux";
import { setModal, addToast } from "../../../actions/index";
import useKeyPress from '../../../hooks/useKeyPress';

function ConnectedAddPlaylist({
  pathApi = null, data = [], cancelClick, style,
  api, setModal, addToast, storePlaylists, isConnected, enable, storeAuth,
  onlyCreate = false
}) {
  const { items } = useApiOrLocal(api, pathApi, data);
  const [playlistSelected, setPlaylistSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const enterPress = useKeyPress('Enter');

  const addToLocal = useCallback((id, tracks) => {
    let updateTracks = [];
    if (pathApi) {
      updateTracks = [...tracks, ...items];
    } else {
      updateTracks = Array.isArray(data) ? [...tracks, ...data] : [...tracks, data];
    }
    storePlaylists.update(id, `tracks`, updateTracks);
    storePlaylists.update(id, `track_count`, updateTracks.length);
    cancelClick();
  }, [pathApi, items, data, storePlaylists, cancelClick])

  const reporting = useCallback((data) => {
    const dataEvent = data.map( x => {
      const source_item_type = (x.from && x.from.includes(`charts`)) ? `Playlist`: `Release`;
      const source_item_id = (x.from && x.from.includes(`charts`)) ? x.from.split(`/`).pop() : x.releaseID;
      return { track_id: x.id, source_item_type, source_item_id }
    } );
    api.postR(`/events/add-to-playlist/`, dataEvent);
  }, [api]);

  const checkDuplicate = useCallback((id, dataUsed, name) => { //CHECK DUPLICATED ITEMS
    const validClick = () => {
      const previews = dataUsed.filter( x => x.is_available_for_streaming === false );
      const selection = dataUsed.filter( x => x.is_available_for_streaming === true ).map(x => x.id);
      storePlaylists.addTracksToPlaylistAPI(id, selection);
      cancelClick();
      if (previews.length > 0) {
        addToast({ content: <span>{previews.length} track(s) not added to '{name}'. Download only, full-track streaming is unavailable.</span>, typeClass: 'warning', iconStyle: { padding: '32px 16px', marginRight: 16 } });
      }
      setTimeout(() => { 
        if (selection.length > 0) {
          addToast({ content: <span>{selection.length} track(s) added to '{name}'.</span>, typeClass: 'success', iconStyle: { padding: 16, marginRight: 16 } });
        }
      }, 1000);
    }
    storePlaylists.getTracks(id).then((res) => {
      const resultsTracks = res.data.results.map( x => x.track );
      const duplicated = dataUsed.filter( x => resultsTracks.find(y => y.id === x.id) ).length;
      if (duplicated > 0) {
        setModal({ //V2
          content: (
            <ModalCTA
              title={`Duplicate found`}
              description={`${duplicated} of the selected tracks, already found in this playlist.`}
              styleContainer={{marginTop: `-60%`, marginLeft: `-10%`}}
              styleBody={{gap: 32}}
              classModal={`bottom-reduce`}
            >
              <ModalButton label={`Add anyway`} className={`transparent-grey`} onClick={validClick} keyPress={true} />
              <ModalButton label={`Cancel`} className={`cancel`}  />
            </ModalCTA>
          )
        })
      } else {
        validClick();
      }
    });
  }, [storePlaylists, setModal, addToast, cancelClick])

  const prepareToApi = useCallback((id, name) => {
    const dataUsed = (pathApi) ? items : (Array.isArray(data) ? data : [data]);
    reporting(dataUsed);
    checkDuplicate(id, dataUsed, name);
  }, [pathApi, items, data, reporting, checkDuplicate])

  const addToPlaylist = useCallback((playlist) => () => {
    if (playlist) {
      setLoading(true);
      const id = playlist.id;
      const tracks = playlist.tracks;
      const name = playlist.name;

      if (isConnected) { // All Account
        prepareToApi(id, name)
      } else { // No Account
        addToLocal(id, tracks);
      }
    }
  }, [isConnected, addToLocal, prepareToApi]);

  useEffect(() => {
    if (enterPress) {
      addToPlaylist(playlistSelected)();
    }
  }, [enterPress, addToPlaylist, playlistSelected]); // Warning but need

  const extraAction = (newID, name) => {
    addToast({ content: <span>Playlist '{name}' created.</span>, typeClass: 'success', iconStyle: { padding: 16, marginRight: 16 } });
    addToPlaylist({id: newID, tracks: [], name})();
  }

  const newPlaylist = () => {
    if (enable) {
      setModal({ // V2
        content: (
          <ModalCTA
            title={`Create playlist`}
            styleContainer={{marginTop: `-50%`, marginLeft: `-5%`}}
            styleBody={{gap: 16}}
            styleGroupCta={{gap: 32}}
            classModal={`bottom-reduce`}
          >
            <NewPlaylist extraAction={extraAction} />
          </ModalCTA>
        )
      });
    } else {
      storeAuth.link();
    }
  }

  useEffect(() => {
    if (onlyCreate) {
      newPlaylist();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onlyCreate])

  const isSelected = (id) => (playlistSelected && playlistSelected.id === id);
  const clickPlaylist = (playlist) => () => setPlaylistSelected({id: playlist.id, tracks: playlist.tracks, name: playlist.name});

  return (
    <FormContext.Provider value={{data}}>
      <div className={`cta transparent-grey flexRow center`} onClick={newPlaylist} >
        <IconPlus size={20} className={`container-icon-plus`} color={ Config.GREY_2 } />
        <span>Create playlist</span>
      </div>
      <div className={`flexColumn modal-playlists-list`}>
      { storePlaylists.playlists && storePlaylists.playlists.filter(x => !x.pm ).map( (p, i) => {
        return (
          <Playlist key={`addPlaylist-${i}`} index={i} id={p.id}
            name={p.name} owner={null} countTracks={p.track_count}
            cover={(p.release_images && p.release_images.length > 0) ? p.release_images : [Config.DEFAULT_IMG]}
            length_ms={p.length_ms}
            isSelected={isSelected(p.id)}
            onClick={clickPlaylist(p)}
          />
        )
      }) }
      </div>
      <div className={`login-actions`}>
        { <Button label={`Add to playlist`} className={`cta ${playlistSelected ? `primary` : `bg-black-5`} type-regular type-placeholder ${loading && 'execute'} `} onClick={addToPlaylist(playlistSelected)} /> }
      </div>
    </FormContext.Provider>
  )
}

ConnectedAddPlaylist.propTypes = {
  pathApi: PropTypes.string,
  data: PropTypes.any,
  style: PropTypes.object,
  cancelClick: PropTypes.func,
  enable: PropTypes.bool,
}

const AddPlaylist = connect(
  state => ({
    api: state.api,
    isConnected: state.isConnected,
    enable: (state.isConnected),
    storeAuth: state.storeAuth,
    storePlaylists: state.storePlaylists,
  }),
  dispatch => ({
    setModal: content => dispatch(setModal(content)),
    addToast: content => dispatch(addToast(content))
  })
)(ConnectedAddPlaylist);

export default AddPlaylist;
